import { useMemo } from "react";
import { LoanChart } from "../charts/LoanChart";
import { formatINR } from "../../../lib/loanMath";

const DRAWN = [
  { key: "before", label: "Outstanding — current plan", color: "#8A8A8A", dash: "6 3" },
  { key: "after", label: "Outstanding — with suggestion", color: "#2B7BB9", dash: null },
];
const SETTINGS = { chartType: "line", display: "rupees", window: "full", measure: "per_period", split: false };
const NO_MARKERS = { today: null, crossover: null, events: [] };

function colors() {
  const v = (n) => { try { return getComputedStyle(document.documentElement).getPropertyValue(n).trim(); } catch { return ""; } };
  const h = (n, fb) => (v(n) ? `hsl(${v(n)})` : fb);
  return { fg: h("--muted-foreground", "#777"), grid: h("--border", "#ccc"), accent: h("--secondary", "#B89B72"), bg: h("--card", "#fff"), text: h("--foreground", "#222") };
}

function Tip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  return (
    <div className="card-flat p-2 text-[11px] space-y-0.5" data-testid="ai-chart-tooltip">
      <b>{r.label}</b>
      <div>Current plan: {formatINR(r.before)}</div>
      <div>With suggestion: {formatINR(r.after)}</div>
    </div>
  );
}

// Before vs After outstanding — reuses the Feature 6 chart component.
export function AiBeforeAfterChart({ chart }) {
  const data = useMemo(() => (chart || []).map((r) => ({
    ...r, status: "Paid", v_before: r.before, v_before__p: r.before, v_before__f: null, v_after: r.after, v_after__p: r.after, v_after__f: null,
  })), [chart]);
  const c = useMemo(colors, []);
  if (data.length < 2) return null;
  return (
    <div className="card-flat p-4" data-testid="ai-before-after-chart">
      <div className="eyebrow text-[9px] mb-1">Before vs After — total outstanding</div>
      <div className="flex gap-3 text-[10px] text-muted-foreground mb-1">
        {DRAWN.map((d) => (
          <span key={d.key} className="inline-flex items-center gap-1">
            <svg width="16" height="6" aria-hidden="true"><line x1="0" y1="3" x2="16" y2="3" stroke={d.color} strokeWidth="2.5" strokeDasharray={d.dash || undefined} /></svg>
            {d.label}
          </span>
        ))}
      </div>
      <LoanChart data={data} drawn={DRAWN} settings={SETTINGS} hidden={new Set()} markers={NO_MARKERS} colors={c}
                 mode="combined" loanNames={[]} uid="ai-ba" onZoom={() => {}} tooltip={<Tip />} />
    </div>
  );
}
